import { LGraphNode, LiteGraph } from "litegraph.js";
import { addDrivableSlider, finalizeDrivableSliders, syncDrivableSliders } from "../utils/addDrivableSlider.js";

/**
 * RemapNode
 * ---------
 * Maps an input range to an output range.
 * Turn a 0–1 timing value into any arbitrary range.
 */
export class RemapNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Remap";

    this.properties = {
      inMin: 0,
      inMax: 1,
      outMin: 0,
      outMax: 100,
      clamp: true,
    };

    this.addInput("Value", "number");
    this.addOutput("Value", "number");

    addDrivableSlider(this, "In Min", "inMin", 0, -1000, 1000, 0.1);
    addDrivableSlider(this, "In Max", "inMax", 1, -1000, 1000, 0.1);
    addDrivableSlider(this, "Out Min", "outMin", 0, -1000, 1000, 0.1);
    addDrivableSlider(this, "Out Max", "outMax", 100, -1000, 1000, 0.1);

    finalizeDrivableSliders(this, 1);

    this.addWidget("toggle", "Clamp", true, (val) => {
      this.properties.clamp = val;
    });

    this.size = [200, 140];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  onDrawForeground(ctx) {
    const w = this.size[0];
    const h = this.size[1];
    ctx.fillStyle = "rgba(255,255,255,0.4)";
    ctx.font = "9px monospace";
    ctx.fillText(`= ${(this._lastResult || 0).toFixed(2)}`, 10, h - 6);
  }

  onExecute() {
    syncDrivableSliders(this);

    const input = this.getInputData(0) || 0;
    const { inMin, inMax, outMin, outMax, clamp } = this.properties;

    let t = (input - inMin) / (inMax - inMin || 1);
    if (clamp) t = Math.max(0, Math.min(1, t));
    const result = outMin + t * (outMax - outMin);

    this._lastResult = result;
    this.setOutputData(0, result);
  }
}

LiteGraph.registerNodeType("utility/Remap", RemapNode);
